import Source from "../public/source.json"
import Build from "../build.json"

const build = Build.build
const backend_url = Source.source
const messages = {
  successfulAction: "Acción exitosa.",
  failedAction: "Acción fallida.",
  notDoneAdd: "No se pudo agregar el registro",
  notDoneEdit: "No se pudo cambiar el registro",
  notDoneDelete: "No se pudo borrar el registro"
}
const colorsChart = {
  electricblue: "#0984e3",
  nightblack: "#1e272e",
  cyanneon: "#00cec9",
  cloudwhite: "#f5f6fa",
  s3deepblue: "#1D4E89",
  s3darkred: "#BC270A"
}
const colors = {
  color01: "#edfea7",
  color02: "#bed868",
  color03: "#fff1a7",
  color04: "#ffe295",
  color05: "#ffce95",
  color06: "#ffc0ad",
  color07: "#ffadad",

  color08: "#97d868",
  color09: "#d8c3ff",
  color10: "#ffafff",
  color11: "#a8d3ff",
  color12: "#62d5b6",
  color13: "#ffc3fd",
  color14: "#a8ebff",
  color15: "#62d581",
  
  color16: "#1D4E89",
  color20: "#AD1905"

  // color1: "#F79256",
  // color2: "#FBD1A2",
  // color3: "#7DCFB6",
  // color4: "#00B2CA",
  // color6: "#759307",
  // color7: "#90B704",
  // color8: "#E0B605",
  // color9: "#DD8505",
  // color10: "#DD2C0A",
  // color6: "#7FA80F",
  // color7: "#A6E319",
  // color8: "#F5CF18",
  // color9: "#F7A006",
  // color10: "#F5451B",
  // color11: "#BC270A",
}
const colorsAlt = {
  color1: "#F79256",
  color2: "#FBD1A2",
  color3: "#7DCFB6",
  color4: "#00B2CA",
  color5: "#1D4E89",
  color6: "#759307",
  color7: "#90B704",
  color8: "#E0B605",
  color9: "#DD8505",
  color10: "#DD2C0A",
  color11: "#AD1905",
  // color6: "#7FA80F",
  // color7: "#A6E319",
  // color8: "#F5CF18",
  // color9: "#F7A006",
  // color10: "#F5451B",
  // color11: "#BC270A",
}
const configSimpleConfirm = {
  focusCancel: true, 
  cancelButtonText: "Cancelar", 
  cancelButtonColor: "lightblue", 
  width:400
}
const configSimpleAlert = {
  width: 400,
  timer: 3000  
}

export default {
  backend_url,
  build,
  messages,
  colors,
  colorsAlt,
  colorsChart,
  configSimpleAlert,
  configSimpleConfirm,
  apiKey: "AIzaSyAt4af2UvDfNLzoWfppcgHU_RC00EPKyD8"
}
